const farmEn = {
    farm: require('../../lang/en/farm/Farm').default,
    dailyLogs: require('../../lang/en/farm/DailyLogs').default,
    serviceReq: require('../../lang/en/farm/ServiceRequest').default,
    farmExp: require('../../lang/en/farm/FarmExpense').default,
};

export default farmEn;